"use client";
import React, { useState } from "react";
import "./cssAnimation.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Function to fetch and download resume
  const downloadResume = async () => {
    try {
      setDownloading(true);

      const response = await fetch("/.netlify/functions/getLatestResume");
      if (!response.ok) throw new Error("Failed to fetch resume");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Prajeeth_Resume.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading resume:", error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <nav className="md:fixed top-0 w-[100vw] flex items-center justify-between flex-wrap bg-opacity-25 bg-gray-600 backdrop-filter backdrop-blur-md p-4 px-10 z-[2] m-0">
      <div className="block lg:hidden">
        <button
          onClick={toggleMenu}
          className="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white"
        >
          <svg
            className="fill-current h-3 w-3"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>

      <div
        className={`w-full ${
          menuOpen ? "block" : "hidden lg:flex-grow"
        } lg:flex lg:items-center lg:w-auto transition-transform duration-300 ease-in-out transform`}
      >
        <div className="text-sm">
          <a
            href="#introSection"
            className="block mt-4 lg:inline-block lg:mt-0 text-teal-400 hover:text-white mr-4"
          >
            Intro
          </a>
          <a
            href="#techStackSection"
            className="block mt-4 lg:inline-block lg:mt-0 text-teal-400 hover:text-white mr-4"
          >
            Tech Stack
          </a>
          <a
            href="#timelineSection"
            className="block mt-4 lg:inline-block lg:mt-0 text-teal-400 hover:text-white mr-4"
          >
            Timeline
          </a>
          <a
            href="#projectSection"
            className="block mt-4 lg:inline-block lg:mt-0 text-teal-400 hover:text-white mr-4"
          >
            Projects
          </a>
          <a
            href="#interestSection"
            className="block mt-4 lg:inline-block lg:mt-0 text-teal-400 hover:text-white"
          >
            Interests
          </a>
        </div>

        <div className="lg:ml-auto">
          <button
            onClick={downloadResume}
            disabled={downloading}
            className="inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-teal-500 hover:bg-white mt-4 lg:mt-0 disabled:opacity-50"
          >
            {downloading ? "Downloading..." : "Download Resume"}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
